var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButtonLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 23c5.523 0 10-4.477 10-10S15.523 3 10 3 0 7.477 0 13s4.477 10 10 10z",
    id: "7bicr82vya"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d18pernzab",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7bicr82vya"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 22 22)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E6E7E8",
    width: 44,
    height: 44,
    rx: 22
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 9)",
    stroke: "#006997"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13 26-4-4 4-4M7 8l4-4-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#d18pernzab)",
    strokeWidth: 3,
    strokeDasharray: "19,12",
    xlinkHref: "#7bicr82vya"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonLoader);
export default __webpack_public_path__ + "static/media/menu-button-loader.2d60bb70883fa62f72d4234198904c58.svg";
export { ForwardRef as ReactComponent };